export const getFileIcon = type => {
  const fileTypes = {
    pdf: "20-course-file-pdf",
    audio: "20-course-file-audio",
    video: "20-course-file-video",
    image: "20-course-file-image",
    default: "20-course-file",
  };
  return fileTypes[type] || fileTypes.default;
};

export const getFileType = file => {
  if (file.content_type.includes("pdf")) {
    return "pdf";
  }
  if (file.content_type.includes("audio")) {
    return "audio";
  }
  if (file.content_type.includes("video")) {
    return "video";
  }
  if (file.content_type.includes("image")) {
    return "image";
  }
  return "File";
};
